function parseBloomreachInputField(inputField) {
    return inputField ? {
        placeholder: inputField.placeholder,
        id: inputField.inputId,
        type: inputField.type || 'text'
    } : undefined;
}

export { parseBloomreachInputField };
//# sourceMappingURL=parse-bloomreach-input-field.js.map
